module.exports = __webpack_public_path__ + "static/media/review_3.21ab4098.jpg";